export default "__VITE_ASSET__zWrYRIo1__"